var _path;
import * as React from "react";
function SvgToggleOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14c3.313 0 6 2.631 6 6 0 3.313-2.688 6-6 6-3.369 0-6-2.688-6-6 0-3.369 2.631-6 6-6zm-4 6c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4zm20 10H12C6.477 30 2 25.525 2 20s4.477-10 10-10h16c5.525 0 10 4.475 10 10s-4.475 10-10 10zm0-18H12a8 8 0 100 16h16a8 8 0 008-8 8 8 0 00-8-8z"
  })));
}
export default SvgToggleOff;